import { Col, Row } from "react-bootstrap";
import moment from "moment/min/moment-with-locales";
import { Suspense } from "react";
import { Await, useRouteLoaderData } from "react-router-dom";
import { renderTrendIcon } from "../helperRenders";

export default function SongRow({
    item,
    setCatalogueSong,
    showSpins = false,
    showReleaseYear = false,
    showFirstOn = false,
    showFirstPlay = false,
    showTrend = false,
    firstPlayColXl = 1,
}) {
    const { competitorRadios } = useRouteLoaderData("root");

    return (
        <Row onClick={() => setCatalogueSong(item)} className={`py-1 border-bottom align-items-center hoverable fs-8-xs`}>
            {showTrend && (
                <Col xs={"auto"} xl={2} className="pe-0 pe-xl-og align-content-center order-xl-last">
                    <span className="d-flex fw-bold fw-xl-normal justify-content-center">{renderTrendIcon(item.trend)}</span>
                </Col>
            )}
            <Col>
                <Row className="ps-2 ps-xl-0">
                    <Col xs={"auto"} xl className={`align-content-center ps-1 ${showTrend ? "px-1" : "pe-1"} ps-xl-og pe-xl-og fs-7 fw-bold fw-xl-normal`}>
                        {item.artist}
                    </Col>
                    <Col xs="auto" className=" align-content-center px-0 d-xl-none">
                        -
                    </Col>
                    <Col xs={"auto"} xl className=" align-content-center px-1 ps-xl-og pe-xl-og fs-7 fw-bold fw-xl-normal">
                        {item.title}
                    </Col>
                </Row>
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            {showReleaseYear && (
                <Col xs={"auto"} xl={2} className=" align-self-center text-center">
                    <span className=" d-xl-none">Release year: </span>
                    <span className=" fw-bold fw-xl-normal">{item.release_year}</span>
                </Col>
            )}
            {showSpins && (
                <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                    <span className=" d-xl-none">Spins: </span>
                    <span className=" fw-bold fw-xl-normal">{item.spins}</span>
                </Col>
            )}
            {showFirstPlay && (
                <>
                    <Col xs={12} className="d-xl-none"></Col>
                    <Col xs={"auto"} xl={firstPlayColXl} className=" align-content-center text-center">
                        <span className=" d-xl-none">First played: </span>
                        <span className=" fw-bold fw-xl-normal">{moment(item.first_play).format("L HH:mm")}</span>
                    </Col>
                </>
            )}
            {showFirstOn && (
                <>
                    {!showFirstPlay && <Col xs={12} className="d-xl-none"></Col>}
                    <Col xs={"auto"} xl={2} className=" align-content-center text-center">
                        <span className=" d-xl-none">First on: </span>
                        <Suspense>
                            <Await resolve={competitorRadios}>
                                {resolvedCompetitorRadios => (
                                    <span className=" fw-bold fw-xl-normal">
                                        {resolvedCompetitorRadios.data.find(x => x.radio_id === item.first_on)?.radio_name}
                                    </span>
                                )}
                            </Await>
                        </Suspense>
                    </Col>
                </>
            )}
        </Row>
    );
}
